<div class="bloc-content-body">
  <div class="content top">
    <p>Veuillez télécharger votre pièce d'identité recto-verso puis prendre une photo de vous avec cette pièce
      d'identité en main.
    </p>
    <ul>
      <li>Seules les pièces d'identité en cours de validité sont acceptées.</li>
      <li>Votre pièce d’identité doit être nette et lisible (nom, prénom, date de naissance et photo).</li>
    </ul>
  </div>

  <div class="form-group radio-group auto-grid inputfile">
    @if (identityFrontFile == null) {
      <div class="mb-4">
        <input
          type="file"
          class="form-control"
          id="identityFront"
          accept="application/pdf,image/*"
          style="cursor: pointer"
          (change)="getFile($event, environment.data.identityFrontFileTypeSlug)"
          />
        <label class="label-text" for="identityFront">Télécharger votre pièce d'identité - recto</label>
        @if (submitted) {
          <p class="error-msg">Ce champ est obligatoire.</p>
        }
      </div>
    }
    <div>
      @if (identityFrontFile != null) {
        <span class="delete-btn">
          <div (click)="deleteFile(environment.data.identityFrontFileTypeSlug);">X</div> {{ identityFrontFile.name }}
        </span>
      }
    </div>
    <br/><br/>
    @if (identityBackFile == null) {
      <div>
        <input
          type="file"
          class="form-control"
          id="identityBack"
          accept="application/pdf,image/*"
          style="cursor: pointer"
          (change)="getFile($event, environment.data.identityBackFileTypeSlug)"
          />
        <label class="label-text" for="identityBack">Télécharger votre pièce d'identité - verso</label>
        @if (submitted) {
          <p class="error-msg">Ce champ est obligatoire.</p>
        }
      </div>
    }
    <div>
      @if (identityBackFile != null) {
        <span class="delete-btn">
          <div (click)="deleteFile(environment.data.identityBackFileTypeSlug);">X</div> {{ identityBackFile.name }}
        </span>
      }
    </div>
  </div>

  @if (isMobileDevice) {
    <div class="grid">
      <label  class="box-grid" for="captureSelfie">
        <input id="captureSelfie" type="radio" [checked]="captureSelfieType == 'captureSelfie'" name="selfie" (click)="setSelfieTypeValue('captureSelfie')" />
        <label class="form-check-label" for="captureSelfie">Prendre une photo</label>
      </label>
      <label  class="box-grid" for="uploadSelfie">
        <input id="uploadSelfie" type="radio" [checked]="captureSelfieType == 'uploadSelfie'" name="selfie" (click)="setSelfieTypeValue('uploadSelfie')"/>
        <label class="form-check-label" for="uploadSelfie">Télécharcher une photo</label>
      </label>
    </div>
  }

  @if (captureSelfieType == 'uploadSelfie' && isMobileDevice) {
    <div class="form-group radio-group auto-grid inputfile">
      @if (selfieCapture.file == null) {
        <div>
          <input
            type="file"
            class="form-control"
            id="selfieUploaded"
            accept="application/pdf,image/*"
            style="cursor: pointer; margin-top: 30px"
            (change)="getFile($event, 'selfieUploaded')"
            />
          <label class="label-text" for="selfieUploaded">Télécharger votre selfie</label>
          @if (submitted) {
            <p class="error-msg">Ce champ est obligatoire.</p>
          }
        </div>
      }
      <div>
        @if (selfieCapture.file != null) {
          <span class="delete-btn" style="margin-top: 14px">
            <div (click)="deleteFile('selfieUploaded');">X</div> {{ getSelfieCaptureFileName() }}
          </span>
        }
      </div>
    </div>
  }

  @if (captureSelfieType == 'captureSelfie' && (selfieCapture.file == null || selfieCapture.baseUrl) && isMobileDevice) {
    <div class="identity-files">
      <div [style.display]="displayCanvas && selfieCapture.file == null ? 'flex' : 'none'"
        class="content">
        <ul>
          <li>Installez-vous dans un lieu suffisamment éclairé et sur une surface plate
            pour éviter les reflets (flash désactivé).
          </li>
          <li>Placez l’objectif de la caméra à la hauteur de vos yeux.
          </li>
          <li>Positionnez votre document d’identité sous votre visage afin que votre visage et votre pièce
            d'identité soient nets (si l’un ou l’autre est flou, votre commande sera annulée).
          </li>
          <li>Prenez une photo de vous (un selfie) et de votre document d'identité, en vous assurant que rien
            ne cache votre visage ni votre pièce d’identité.
          </li>
        </ul>
      </div>
      <div class="video-container">
        <video
          [style.display]="displayCanvas && selfieCapture.file == null ? 'flex' : 'none'"
          #video
          id="video"
          autoplay
        ></video>
        <canvas
          [style.display]="!displayCanvas && selfieCapture.file != null && selfieCapture.baseUrl != null ? 'flex' : 'none'"
          #canvas
          id="canvas"
          [width]="WIDTH"
          [height]="HEIGHT"
        ></canvas>
        @if (!displayCanvas && selfieCapture.file != null && selfieCapture.baseUrl) {
          <div
            class="text-center basket-validate-button-container ng-star-inserted"
            >
            <button
              id="scroll-target-1"
              class="cta_btn level_2 column"
              (click)="takeNewPicture();scrollToHandler('scroll-target-1');"
            >Prendre une autre photo</button>
          </div>
        }
      </div>
      @if (selfieCapture.file == null) {
        <div class="text-center basket-validate-button-container ng-star-inserted">
          @if (!displayCanvas) {
            <button
              id="scroll-target-2"
              class="cta_btn level_2 column"
              (click)="setupDevices(true);scrollToHandler('scroll-target-2');"
              >Prendre une photo<span></span></button>
            }
            @if (displayCanvas) {
              <button
                class="cta_btn level_2 column"
                (click)="capture(environment.data.selfieWithIdentityFileTypeSlug)"
              >Capturer</button>
            }
          </div>
        }
      </div>
    }

    <div id="documents" class="basket-validate-button-container">
      <label for="cgv" class="box-grid">
        <input class="checkbox" type="checkbox" id="cgv" (click)="setCheckbox('cgv', $event)"/>
        <h3>Je reconnais avoir pris connaissance et accepte les Conditions Générales de Vente (CGV).<span class="bold-red-text">*</span></h3>
      </label>
      <label for="actuality" class="box-grid">
        <input class="checkbox" type="checkbox" id="actuality" (click)="setCheckbox('actuality', $event)"/>
        <h3>J'accepte de recevoir des communications concernant des offres promotionnelles et des actualités marketing.</h3>
      </label>
    </div>

    @if (((selfieCapture.file !== null && isMobileDevice) || (selfieCapture.file == null && !isMobileDevice)) && identityFrontFile !== null && identityBackFile !== null && acceptCgv) {
      <div class="text-center basket-validate-button-container ng-star-inserted">
        <button class="cta_btn level_2 column" (click)="save()">Valider</button>
      </div>
    }
  </div>
